import React from 'react'
import '../Styles/Why_travel_with_us.css';

const Why_travel_with_us = () => {
  return (
    <section className="why-travel">
      <div className="why-travel-title">
        <h1>Why Travel With Us ?</h1>
      </div>

      <div className="why-travel-content">
        {/* Left Side */}
        <div className="why-left">
          <div className="why-card">
            <h3>🌴 Handpicked Destinations</h3>
            <p>
              We curate only the most breathtaking and unique locations, ensuring every trip
              is packed with authentic experiences you’ll remember forever.
            </p>
          </div>
<hr/>
          <div className="why-card">
            <h3>📞 24/7 Travel Support</h3>
            <p>
              From booking to boarding, our team is here for you anytime, anywhere. Your peace
              of mind is our priority.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="why-divider"></div>

        {/* Right Side */}
        <div className="why-right">
          <div className="why-card">
            <h3>💰 Best Price Guarantee</h3>
            <p>
              Get the best value for your journey with competitive rates and no hidden costs —
              because great adventures shouldn’t come with a heavy price tag.
            </p>
          </div>
<hr/>
          <div className="why-card">
            <h3>🗺️ Tailored Itineraries</h3>
            <p>
              No two travelers are the same — that’s why we design personalized itineraries
              that match your style, pace, and passions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why_travel_with_us;
